// ===================== component import =================== //
import React,{useEffect, useState, useContext} from 'react'
import { useNavigate, Navigate  } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'


// =================== Module import =============== //
import { toAbsoluteUrl } from "../../../_template/helpers/CommonFunction";
import  AppContext  from '../../routing/AuthContext';

// ================= component import ============== //
import { storePermission } from '../../redux/managePermissionSlice';
import ValidationMessage from '../../component/common/ValidationMessage';
import ButtonLoader from '../../component/common/ButtonLoader';
import AlertMessage from '../../component/common/AlertMessage';

const Login = (props) => {
    const authCtx = useContext( AppContext );
    const navigate = useNavigate();
    useEffect(() => {
        document.body.style.backgroundImage =  `url('${toAbsoluteUrl('media/auth/bg10.jpeg')}')`;
    },[])
    const api_base_url = process.env.REACT_APP_API_URL;

    // ------ get subdomain -------- //

    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const subdomain = (parts.length > 2) ? parts[0] : '';

    // ------------ password shown and hide ------------- //
    const [passwordShown, setPasswordShown] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown)
    }
    // ---------- login submit ------------ //
    const [loginFormErorr, setLoginFormError] = useState({});
    const [loginFormData, setLoginFormData] = useState({
        username : "", 
        password : "" ,
        application_url: ""
    });
    const validateField = (name, value) => {
        let error = "";
        if (name === "username") {
            if (!value) {
                error = "Username is required";
            } 
        }
        if(name === 'password'){
            if (!value) {
                error = "Password is required";
            }
        }
        if(!subdomain){
            if(name === 'application_url'){
                if (!value) {
                    error = "Application URL is required";
                }
            }
        }
        return error;
    };
    const inputChangeHandler = (event) => {
        const { name, value } = event.target;
        const fieldError = validateField(name, value);
        setLoginFormError((prevErrors) => ({
            ...prevErrors,
            [name]: fieldError,
        }));
        setLoginFormData((prevData) => ({
            ...prevData,
            [name]: value.trim(),
        }));
    }
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    const applicationUrl = localStorage.getItem('subdomain');
    
    const [isCheckedValue, setIsCheckedValue] = useState(false);
    useEffect(() => {
        if(!!username && !!password){
            setIsCheckedValue(true)
            setLoginFormData({
                username : username, 
                password : password ,
                application_url: applicationUrl
            })
        }
    },[])
    const handleCheckboxChange = (event) => {
        setIsCheckedValue(event.target.checked);
    };
    const [ loginResponse, setLoginResponse ] = useState({
        res_type : '',
        title : '',
        sub_title : '',
    });
    const [isShowButtonLoader, setIsButtonLoader] = useState(false);
    const loginSubmitHandler = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in loginFormData) {
            newErrors[key] = validateField(key, loginFormData[key]);
        }
        setLoginFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setIsButtonLoader(true)
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                }
            };
            loginFormData.sass_id = localStorage.getItem('sass_id');
            loginFormData.sub_domain = localStorage.getItem('subdomain');

            await axios.post(`${api_base_url}api/login`, loginFormData, api_headers)
            .then(async (res) => {

                // console.log(res)
                // return

                if(res.data.status === 'success') {
                    setLoginResponse({
                        res_type : 'success',
                        title : 'Authentication verified',
                        sub_title : res.data.message,
                    })

                    const _data = res.data.data;
                    if(!subdomain){
                        localStorage.setItem('sass_id', _data.data.sass_id);
                        localStorage.setItem('subdomain', _data.sub_domain);
                        localStorage.setItem('business_name', _data.business_name);
                        localStorage.setItem('business_email', _data.business_email);
                    }

                    setLoginFormError({});
                    localStorage.setItem('loginInfo', JSON.stringify(_data.data));
                    if(isCheckedValue){
                        localStorage.setItem('username' , loginFormData.username)
                        localStorage.setItem('password' , loginFormData.password)
                    }else{
                        localStorage.removeItem('username')
                        localStorage.removeItem('password')
                    }
                    if(res.data.data.user_type === "E") {
                        localStorage.setItem('agent_id' , res.data.data.data.unique_id)
                    }
                  
                    setTimeout(() => {
                        authCtx.login({
                            token : res.data.data.token, 
                            type: res.data.data.user_type,
                            loginData: JSON.stringify(res.data.data.data)
                        })
                        setLoginFormData({
                            username : "", 
                            password : "" ,
                        });
                    }, 1000);

                } else if(res.data.status === 'error') {
                    setLoginResponse({
                        res_type : 'danger',
                        title : 'Authentication Failed',
                        sub_title : res.data.message,
                    })
                }
            })
            .catch((error) => {
                console.error(error);
            })
            setIsButtonLoader(false)
        }
    }
    return (
        <>
            <div className="d-flex flex-column flex-root" id="sai_app_root">
                <div className="d-flex m-auto justify-content-center align-items-center vh-100">
                    <div className="d-flex flex-lg-row-fluid">
                        <div className="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100">
                            <img className="theme-light-show mw-100 w-lg-400px mb-10 mb-lg-20" src={toAbsoluteUrl('media/auth/tvsaibot.png')} alt='' />
                            <h1 className="text-gray-800 fs-2qx fw-bold text-center mb-7">You’ve Arrived {props.data ? 'at ' + props.data.business_name : ''} </h1>
                            <div className="text-gray-600 fs-base text-center fw-semibold">In this kind of post,
                            <a href="#" className="opacity-75-hover text-primary me-1">the blogger</a>introduces a person they’ve interviewed
                            <br />and provides some background information about
                            <a href="#" className="opacity-75-hover text-primary me-1">the interviewee</a>and their
                            <br />work following this is a transcript of the interview.</div>
                        </div>
                    </div>
                    <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
                        <div className="bg-body d-flex flex-center rounded-4 w-md-600px p-10">
                            <div className="w-md-400px">
                                <form className="form w-100" onSubmit={loginSubmitHandler}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="text-center mb-11">
                                                <h1 className="text-dark fw-bolder mb-3 fs-2x">Sign In</h1>
                                                <div className="text-gray-500 fw-semibold fs-3">
                                                    Let's step {props.data ? 'into ' + props.data.business_name : ''}
                                                </div>
                                            </div>
                                        </div>
                                        {loginResponse.res_type != '' &&
                                            <div className='col-md-12'>
                                                <AlertMessage
                                                    type = {loginResponse.res_type}
                                                    title = {loginResponse.title}
                                                    sub_title = {loginResponse.sub_title}
                                                    border_type='dashed'
                                                />
                                            </div>
                                        }
                                        {
                                            subdomain === '' &&
                                            <div className="col-md-12">
                                                <div className="fv-row mb-8">
                                                    <input 
                                                        type="text" 
                                                        placeholder="Application URL" 
                                                        name="application_url" 
                                                        autoComplete="off" 
                                                        className={`form-control bg-transparent ${loginFormErorr.application_url ? 'is-invalid' : ''}`}
                                                        style={{ height: '50px' }}
                                                        onChange={inputChangeHandler}
                                                        value={loginFormData.application_url}
                                                    />
                                                    {loginFormErorr.application_url && <ValidationMessage className='text-danger' message ={loginFormErorr.application_url}/>}
                                                </div>
                                            </div>
                                        }
                                        <div className="col-md-12">
                                            <div className="fv-row mb-8">
                                                <input 
                                                    type="text" 
                                                    placeholder="User Name" 
                                                    name="username" 
                                                    autoComplete="off" 
                                                    className={`form-control bg-transparent ${loginFormErorr.username ? 'is-invalid' : ''}`}
                                                    style={{ height: '50px' }}
                                                    onChange={inputChangeHandler}
                                                    value={loginFormData.username}
                                                />
                                                {loginFormErorr.username && <ValidationMessage className='text-danger' message ={loginFormErorr.username}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="fv-row mb-8">
                                                <div className="position-relative">
											        <input 
                                                        className={`form-control bg-transparent ${!passwordShown ? 'inp-secure' : ''} ${loginFormErorr.password ? 'is-invalid' : ''}`} 
                                                        type="text" 
                                                        placeholder="Password" 
                                                        name="password" 
                                                        autoComplete="off" 
                                                        style={{ height: '50px' }}
                                                        onChange={inputChangeHandler}
                                                        value={loginFormData.password}
                                                    />
                                                    {!loginFormErorr.password && 
                                                        <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                                            { !passwordShown && 
                                                                <FontAwesomeIcon 
                                                                    icon={faEye} 
                                                                    className='fs-4 cursor-pointer text-gray-500'
                                                                    onClick={ togglePasswordVisibility }
                                                                />
                                                            }
                                                            { passwordShown && 
                                                                <FontAwesomeIcon 
                                                                    icon={faEyeSlash} 
                                                                    className='fs-4 cursor-pointer text-gray-500'
                                                                    onClick={ togglePasswordVisibility }
                                                                />
                                                            }
                                                        </span>
                                                    }
                                                </div>
                                                {loginFormErorr.password && <ValidationMessage className='text-danger' message ={loginFormErorr.password}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-11">
                                            <label className="form-check form-check-sm form-check-custom form-check-solid me-5 mb-8">
                                                <input className="form-check-input" type="checkbox" value="1" checked={isCheckedValue} 
                                                onChange={handleCheckboxChange}/>
                                                <span className="form-check-label">Remember for next time</span>
                                            </label>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="d-grid mb-10">
                                                <button 
                                                    className={`btn btn-primary ${isShowButtonLoader && 'disabled'}`} 
                                                    type="submit"
                                                >
                                                    {
                                                        isShowButtonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : <span className="indicator-label">Let's Go</span>
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Login